export default __webpack_public_path__ + "static/media/image-profile.58a04e78.svg";